import React from "react";
import { Route, Routes } from "react-router-dom";

import PrivateRoute from "components/PrivateRoute";
import PublicRoute from "components/PublicRoute";
import EmployerSignup from "pages/signUp/employer/EmployerSignup";
import EmployerEnroll from "pages/signUp/employer/EmployerEnroll";
import EmployerTerms from "pages/signUp/employer/EmployerTerms";
import EmployerBilling from "pages/signUp/employer/EmployerBilling";
import EmployerSelfServeController from "pages/signUp/employer/EmployerSelfServeController";
import DashboardLayout from "pages/dashboards/DashboardLayout";
import VerifyEmail from "pages/signUp/VerifyEmail";
import Home from "pages/Home";
import PageNotFound from "pages/PageNotFound";
import { useMediaQuery } from "react-responsive";
import OauthPlaidLink from "../pages/OauthPlaidLink";
import AuthlessPayrollApproval from "pages/dashboards/employerDashboard/processContributions/authlessPayrollApproval/AuthlessPayrollApproval";
import EmployerRequiredUpdates from "pages/dashboards/employerDashboard/requiredUpdates/EmployerRequiredUpdates";
import { useDashboardRoutes } from "hooks/useDashboardRoutes";
import { renderDashboardRoutes } from "routes/renderDashboardRoutes";

const EmployerDashboardLayout = () => {
  const isSmallScreen = useMediaQuery({ maxWidth: 767 });
  const routes = useDashboardRoutes({ isEmployerDashboard: true });
  return (
    <DashboardLayout
      isEmployerDashboard={true}
      isSmallScreen={isSmallScreen}
      routes={routes}
    />
  );
};

const EmployerRoutes = () => {
  const dashboardRoutes = useDashboardRoutes({ isEmployerDashboard: true });
  return (
    <Routes>
      <Route
        path="/"
        element={<PublicRoute path="/" component={EmployerSignup} />}
      />
      <Route
        path="/partner"
        element={
          <PublicRoute path="/partner" component={EmployerSignup} partner />
        }
      />
      <Route
        path="/session/employer-paycheck-auto-approval"
        element={
          <PublicRoute
            path="/session/employer-paycheck-auto-approval"
            component={AuthlessPayrollApproval}
          />
        }
      />
      <Route
        path="/employer/enroll"
        element={
          <PrivateRoute path="/employer/enroll" component={EmployerEnroll} />
        }
      />
      <Route
        path="/employer/verify"
        element={
          <PrivateRoute path="/employer/verify" component={VerifyEmail} />
        }
      />
      <Route
        path="/employer/terms"
        element={
          <PrivateRoute path="/employer/terms" component={EmployerTerms} />
        }
      />
      <Route
        path="/employer/billing"
        element={
          <PrivateRoute path="/employer/billing" component={EmployerBilling} />
        }
      />
      <Route
        path="/employer/info"
        element={
          <PrivateRoute
            path="/employer/info"
            component={EmployerSelfServeController}
          />
        }
      />
      <Route
        path="/required-updates"
        element={
          <PrivateRoute
            path="/required-updates"
            component={EmployerRequiredUpdates}
          />
        }
      />
      <Route
        element={
          <PrivateRoute path="/dashboard" component={EmployerDashboardLayout} />
        }
      >
        {renderDashboardRoutes(dashboardRoutes)}
      </Route>
      <Route
        path="/login"
        element={<PrivateRoute path="/login" component={Home} />}
      />
      <Route
        path="/link-bank"
        element={<PrivateRoute path="/link-bank" component={OauthPlaidLink} />}
      />
      <Route
        path="*"
        element={<PrivateRoute path="*" component={PageNotFound} />}
      />
    </Routes>
  );
};

export default EmployerRoutes;
